import React from 'react';

// Fair wordmark. The "Fair" text is bold black with a small green block
// replacing the dot of the "i" (per the May-2026 brand refresh). If
// AppConfig.brand_logo_url is set we render that image instead — this
// path is the fallback for environments without a hosted logo.
function FairWordmark({ accentColour }) {
  // We render "Fa", then a custom "i" with a coloured dot, then "r".
  // Keeping it inline so it scales with the surrounding font-size and
  // doesn't need an asset round-trip.
  return (
    <span className="brand-wordmark" aria-label="Fair">
      <span>Fa</span>
      <span style={{ position: 'relative', display: 'inline-block' }}>
        <span style={{ visibility: 'hidden' }}>i</span>
        {/* Stem of the i (no dot — we replace it with the accent block) */}
        <span
          aria-hidden="true"
          style={{
            position: 'absolute', left: 0, right: 0, bottom: 0,
            height: '0.68em', borderLeft: '0.18em solid currentColor',
            marginLeft: '0.06em',
          }}
        />
        <span
          aria-hidden="true"
          className="accent-dot"
          style={{
            position: 'absolute', left: 0,
            top: '-0.05em',
            background: accentColour || 'var(--color-primary)',
          }}
        />
      </span>
      <span>r</span>
    </span>
  );
}

export default function BrandHeader({ branding = {}, tagline }) {
  // The bundled fair-logo.jpg already includes the tagline + black rules
  // (it's the full header band). Render it at a fixed 200px wide so it sits
  // as a compact header rather than dominating the page. The source is
  // 1191×135 → 200×23 preserves aspect ratio. Skip the separate `tagline`
  // prop because the image already contains one. Regex matches jpg/jpeg/png
  // so a future format swap doesn't fall back to the text-wordmark path.
  const isBundledFullBand = branding.logoUrl && /\/fair-logo\.(jpg|jpeg|png)$/i.test(branding.logoUrl);
  if (isBundledFullBand) {
    return (
      <div style={{ padding: '6px 0 18px' }}>
        <img
          src={branding.logoUrl}
          alt="Fair — Helping consumers recover funds since 2008"
          width={200}
          height={23}
          style={{ display: 'block', width: 200, height: 23, maxWidth: '100%' }}
        />
      </div>
    );
  }
  return (
    <div className="row" style={{ padding: '6px 0 18px', alignItems: 'center', gap: 16 }}>
      {branding.logoUrl ? (
        <img src={branding.logoUrl} alt="Fair" style={{ height: 36 }} />
      ) : (
        <FairWordmark accentColour={branding.primaryColour} />
      )}
      {tagline ? (
        <div className="small" style={{ color: 'var(--color-muted)', fontWeight: 500 }}>
          {tagline}
        </div>
      ) : null}
    </div>
  );
}
